import { render, staticRenderFns } from "./claims.vue?vue&type=template&id=1d3d1796"
import script from "./claims.vue?vue&type=script&lang=js"
export * from "./claims.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d3d1796')) {
      api.createRecord('1d3d1796', component.options)
    } else {
      api.reload('1d3d1796', component.options)
    }
    module.hot.accept("./claims.vue?vue&type=template&id=1d3d1796", function () {
      api.rerender('1d3d1796', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/frontPageManage/configureManage/configure/components/claims.vue"
export default component.exports